import { createChallenge } from '../helper/challenge-implementation-helper';
export class EmailChallengeRequest {
    constructor(baseUrl, request) {
        this.baseUrl = baseUrl;
        this.request = request;
    }
    async createChallenge(options) {
        return createChallenge(this.baseUrl, this.request, options);
    }
}
/** @public */
export class EmailOtp {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    withScope(scope) {
        this.scope = scope;
        return this;
    }
    withRequestFrom(requestFrom) {
        this.requestFrom = requestFrom;
        return this;
    }
    withEmail(email) {
        this.email = email;
        return this;
    }
    withPhoneNumber(countryCode, number) {
        this.phoneNumber = {
            number,
            countryCode,
        };
        return this;
    }
    build() {
        const request = {
            authFactor: 'EMAIL_OTP',
            scope: this.scope,
            requestFrom: this.requestFrom,
            payload: {
                email: this.email,
                phoneNumber: this.phoneNumber,
            },
        };
        return new EmailChallengeRequest(this.baseUrl, request);
    }
}
//# sourceMappingURL=email-otp.js.map